export default class NotificacionService {
    /**
     *
     * @param {number} id
     * @param {callback} opt.then
     * @param {callback} opt.headers
     * @param {callback} opt.always
     * @param {callback} opt.fail
     */
    static notificar(id, opt) {
        Ajax.put('/api/admin/notificaciones/' + id + '/notificar', {}, opt);
    }
}
